/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clock_Times_OptionInputs */

const en_clock_times_option = /** @type {(inputs: Clock_Times_OptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Clock Times Option`)
};

const fr_clock_times_option = /** @type {(inputs: Clock_Times_OptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Option des temps d’horloge`)
};

const de_clock_times_option = /** @type {(inputs: Clock_Times_OptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uhrzeit-Option`)
};

const it_clock_times_option = /** @type {(inputs: Clock_Times_OptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opzione tempi di orologio`)
};

const ru_clock_times_option = /** @type {(inputs: Clock_Times_OptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Опция «Время по часам»`)
};

const es_clock_times_option = /** @type {(inputs: Clock_Times_OptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opción de horas de reloj`)
};

const zh_cn2_clock_times_option = /** @type {(inputs: Clock_Times_OptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`时钟时间选项`)
};

const ja_clock_times_option = /** @type {(inputs: Clock_Times_OptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`時計時間オプション`)
};

const hi_clock_times_option = /** @type {(inputs: Clock_Times_OptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`घड़ी समय विकल्प`)
};

const pt_pt2_clock_times_option = /** @type {(inputs: Clock_Times_OptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opção de Horários do Relógio`)
};

/**
* | output |
* | --- |
* | "Clock Times Option" |
*
* @param {Clock_Times_OptionInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const clock_times_option = /** @type {((inputs?: Clock_Times_OptionInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clock_Times_OptionInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_clock_times_option(inputs)
	if (locale === "de") return de_clock_times_option(inputs)
	if (locale === "it") return it_clock_times_option(inputs)
	if (locale === "ru") return ru_clock_times_option(inputs)
	if (locale === "es") return es_clock_times_option(inputs)
	if (locale === "zh-CN") return zh_cn2_clock_times_option(inputs)
	if (locale === "ja") return ja_clock_times_option(inputs)
	if (locale === "hi") return hi_clock_times_option(inputs)
	if (locale === "pt-PT") return pt_pt2_clock_times_option(inputs)
	return en_clock_times_option(inputs)
});